'use client'

import { Button, ButtonVariant } from '@graftcode/design-system'

import { Logo } from '@common/components/Logo'
import { useAuthUser } from '@common/hooks/useAuthUser'

import { ACADEMY_HEADER_NAV_TEST_IDS } from '@/shared/docs-test-ids.const'

import { NavbarBreadcrumbs } from './NavbarBreadcrumbs'
import { NavbarSearchBar } from './NavbarSearchBar'
import { NavbarUserActions } from './NavbarUserActions'
import type { AcademyNavbarDesktopProps } from './types'

import styles from './AcademyNavbarDesktop.module.scss'

export function AcademyNavbarDesktop({
  breadcrumbs = [],
  isQuickStart,
  currentUnitIndex = 0,
  totalUnits = 0,
  onSaveAndExit,
}: AcademyNavbarDesktopProps) {
  const { user, isLoading } = useAuthUser()
  const isLoggedIn = !isLoading && !!user

  if (isQuickStart) {
    const progressPercent = totalUnits > 0 ? ((currentUnitIndex + 1) / totalUnits) * 100 : 0

    return (
      <div data-testid={ACADEMY_HEADER_NAV_TEST_IDS.root} className={styles.quickStartNavbar}>
        <div className={styles.left}>
          <a href="/" className={styles.logo}>
            <Logo />
          </a>
        </div>

        <div className={styles.center}>
          {totalUnits > 0 && (
            <span className={styles.unitCounter}>
              Unit {currentUnitIndex + 1} of {totalUnits}
            </span>
          )}
        </div>

        <div className={styles.right}>
          <Button variant={ButtonVariant.Outlined} size="m" onClick={onSaveAndExit}>
            Save &amp; Exit
          </Button>
        </div>

        <div className={styles.progressBar}>
          <div className={styles.progressFill} style={{ width: `${progressPercent}%` }} />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.navbar}>
      <div className={styles.left}>
        <NavbarBreadcrumbs segments={breadcrumbs} />
      </div>

      <div className={styles.right}>
        <NavbarSearchBar />
        {isLoggedIn ? <NavbarUserActions avatarSrc={user?.picture ?? undefined} /> : null}
      </div>
    </div>
  )
}
